export const version = "1.0.0";
export const lastUpdated = "2024-06-15";
export const appName = "ContactHQ";
export const apiEndpoint = "https://contacthq.in";
